import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { BE_HOST, FE_HOST } from "../config/config";
import { useDispatch, useSelector } from "react-redux";
import { USER_TOKEN } from "../redux/types";

function SetCredentials() {
  const { updateToken } = useContext(AuthContext);
  const dispatch = useDispatch();
  const location = useLocation();
  let navigate = useNavigate();

  // Get decoded token from Redux store
  const decodedToken = useSelector((state) => state.userAuth.decodedToken);

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");

    // console.log("set credential--------", token);

    if (token) {
      try {
        const decodedToken = atob(token);
        // console.log('Decoded token from base64:', decodedToken);

        localStorage.setItem("token", token);
        dispatch({
          type: USER_TOKEN,
          payload: {
            token,
            decodedToken: JSON.parse(decodedToken), // Parse the JSON string
          },
        });
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }

    navigate("/react-dashboard");
  }, []);

  // Log the decoded token whenever it changes
  useEffect(() => {
    // console.log('Decoded token from Redux store:', decodedToken);
  }, [decodedToken]);

  return <div></div>;
}

export default SetCredentials;
